export enum Role {
  Administrator = 'Administrator',
  Crew = 'Crew',
}

export const Roles = [Role.Administrator, Role.Crew];
